// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__1YQSg","logo":"Main_logo__1GFdy"};